// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// Fill volume% with min p/d - используется отдельная логика расчета комиссии включающая доп. поля
import { RevenueCommissionValueItemForPerFill } from './RevenueCommissionValueItemForPerFill';
export class RevenueCommissionValueItemForFillVolumeWithMinPD extends RevenueCommissionValueItemForPerFill {
    constructor() {
        super(...arguments);
        this.finalValue = 0.0;
    }
    get FinalValue() {
        return this.finalValue;
    }
    set FinalValue(value) {
        this.finalValue = value;
    }
    GetFixedCommissionValue(commission, ignoreMinMaxCorrection = false, markup = 1.0) {
        if (commission < this.MinTradedValue) {
            return this.MinValue;
        }
        else {
            return this.MinValue + ((commission - this.minTradedValue) * this.finalValue) / 100;
        }
    }
}
